import { useMemo, useRef, useState } from 'react';
import { Select } from 'antd';
import { TagsOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Props {
  /** 選定的標籤 id（undefined = 不篩選）。 */
  onChange: (tagId?: string) => void;
  /** 撐滿父層寬度（手機篩選面板用）；預設為桌機固定寬 180。 */
  full?: boolean;
}

/** 標籤篩選：標籤量大（約 35k），改用伺服器端模糊搜尋，不整包載入。 */
export default function TagFilter({ onChange, full }: Props) {
  const [q, setQ] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  const { data, isFetching } = useQuery({
    queryKey: ['tag-search', q],
    queryFn: () => api.tags({ q, limit: 30 }),
  });

  const search = (v: string) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setQ(v.trim()), 300);
  };

  const options = useMemo(
    () => (data ?? []).map((t) => ({ value: t.id, label: t.name })),
    [data],
  );

  return (
    <Select
      placeholder="標籤"
      allowClear
      showSearch
      filterOption={false}
      loading={isFetching}
      suffixIcon={<TagsOutlined />}
      className={full ? 'w-full' : undefined}
      style={full ? undefined : { width: 180 }}
      notFoundContent={isFetching ? '搜尋中…' : '輸入關鍵字搜尋標籤'}
      onSearch={search}
      onChange={(v) => onChange(v || undefined)}
      options={options}
    />
  );
}
